export function debounce(fn: (...args: unknown[]) => void, delay: number) {
  let timeout: number | null = null;
  return (...args: unknown[]) => {
    if (timeout) {
      window.clearTimeout(timeout);
    }
    timeout = window.setTimeout(() => {
      fn(...args);
      timeout = null;
    }, delay);
  };
}
